export const inputCls =
    "w-full bg-black/60 border border-amber-500/25 rounded-xl px-4 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:outline-none focus:border-amber-400/70 focus:ring-2 focus:ring-amber-500/20 transition-all duration-200";

export const btnPrimary =
    "inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider bg-gradient-to-r from-amber-500 to-amber-600 text-black rounded-full px-5 py-2.5 hover:shadow-[0_0_20px_rgba(200,151,43,0.35)] transition-all duration-200 disabled:opacity-60";

export const btnGhost =
    "inline-flex items-center gap-2 text-xs font-meta tracking-wider uppercase text-amber-200 border border-amber-500/40 rounded-full px-4 py-2.5 hover:bg-amber-500/10 transition-all duration-200 disabled:opacity-60";

export const btnDanger =
    "inline-flex items-center gap-2 text-xs font-meta tracking-wider uppercase text-red-300 border border-red-500/40 rounded-full px-4 py-2.5 hover:bg-red-500/10 transition-all duration-200 disabled:opacity-60";

export const formatErr = (detail, fallback = "Something went wrong.") => {
    if (!detail) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ") || fallback;
    return String(detail);
};

export const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) +
        " · " + d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
};
